/**
 * Formats a phone number to xxx-xxx-xxxx format
 * @param value - The input phone number string
 * @returns Formatted phone number string
 */
export const formatPhoneNumber = (value: string): string => {
  // Remove all non-numeric characters
  const phoneNumber = value.replace(/\D/g, '');
  
  // Limit to 10 digits
  const limitedPhoneNumber = phoneNumber.slice(0, 10);
  
  // Format as xxx-xxx-xxxx
  if (limitedPhoneNumber.length >= 6) {
    return `${limitedPhoneNumber.slice(0, 3)}-${limitedPhoneNumber.slice(3, 6)}-${limitedPhoneNumber.slice(6)}`;
  } else if (limitedPhoneNumber.length >= 3) {
    return `${limitedPhoneNumber.slice(0, 3)}-${limitedPhoneNumber.slice(3)}`;
  } else {
    return limitedPhoneNumber;
  }
};

/**
 * Validates if a phone number is complete (has 10 digits)
 * @param phoneNumber - The phone number string
 * @returns Boolean indicating if phone number is valid
 */
export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  const digits = phoneNumber.replace(/\D/g, '');
  return digits.length === 10;
};